import type { IUserInfo } from "@/hooks/use-user-info";
import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";
import type { IBasePayload } from "@/model/base-payload";
import type { PlanCoverageInfo } from "@/model/demographics";

export type IRequestIdResponse = {
  summary: {
    status_message: string;
    member_id: string;
    status_code: string;
    query_id: string;
    group_id: string;
    query: string;
    query_time: number;
  };
  data: {
    message: string;
    idCardRequestedAt: string;
  };
};

export type IRequestIdPayload = {
  mbrFirstName: string;
  mbrLastName: string;
  subscriberId: string;
  mbrEmail: string;
  mbrAddress: string;
} & IBasePayload;

export const requestIdService = (
  userInfo: IUserInfo,
  activeCoverage: PlanCoverageInfo,
) => {
  const payload: IRequestIdPayload = {
    memberId: userInfo?.memberId,
    groupId: userInfo?.groupId,
    divisionId: userInfo?.divisionId,
    planId: userInfo?.planId,
    mbrFirstName: userInfo?.firstname,
    mbrLastName: userInfo?.lastname,
    mbrEmail: userInfo?.email,
    subscriberId: userInfo?.employeeId,
    mbrAddress: userInfo?.address,
    claimCoverageCode: activeCoverage.claimCoverageCode,
    username: userInfo?.username,
  };

  const config = {
    headers: {
      Authorization: `Bearer ${userInfo.accessToken}`,
      "Content-Type": "application/json",
    },
  };

  return httpClient
    .post(API_ENDPOINTS.REQUEST_ID_CARD, payload, config)
    .then((response) => response.data);
};
